import Chip from '@mui/material/Chip';
import { amber, green, grey } from '@mui/material/colors';
import React from 'react';
import { generatePath } from 'react-router';

import OberonCard from '~components/OberonCard';
import Routes from '~providers/RouteProvider/Routes';

type Props = {
  id: number;
  name: string;
  isActive: boolean;
  isArchived: boolean;
};

const CampaignGroupCard = ({ ref, id, name, isActive, isArchived }: Props & { ref?: React.Ref<HTMLDivElement> }) => {
  const backgroundAndBorderColor = isArchived ? grey[600] : isActive ? green[600] : amber[600];
  const statusName = isArchived ? 'Archived' : isActive ? 'Active' : 'Paused';

  return (
    <OberonCard
      ref={ref}
      to={generatePath(Routes.viewDiallerGroup.path, { diallerGroupId: id.toString() })}
      titleFontWeight={400}
      title={name}
      subHeader={
        <Chip
          sx={{
            marginTop: 2,
            textTransform: 'uppercase',
            fontSize: 10,
            borderRadius: 1,
            height: 20,
            lineHeight: '21px',
            color: '#ffffff',
            fontWeight: 700,
            backgroundColor: backgroundAndBorderColor,
          }}
          label={statusName}
        />
      }
      footerBorderColor={backgroundAndBorderColor}
    />
  );
};

export default CampaignGroupCard;
